<template>
    <div>
        <router-view :hostroletype="hostroletype" :hostroleinnerid="hostroleinnerid"></router-view>
    </div>
</template>

<script>
export default {
    name: 'Finance',
    data() {
        return {
            hostroletype: '',
            hostroleinnerid: ''
        }
    },
    mounted() {},
    methods: {},
    watch: {},
    filters: {},
    computed: {},
    components: {}
}
</script>
